<template>
  <ul class="reorderable-list">
    <li v-for="(item, index) in items" :key="item.id" class="list-item">
      <div class="item-content">
        <span class="item-name">{{ item.name }}</span>
        <div class="item-controls">
          <button 
            class="arrow-btn"
            :disabled="index === 0"
            @click="moveItem(index, 'up')"
          >
            ▲
          </button>
          <button 
            class="arrow-btn"
            :disabled="index === items.length - 1"
            @click="moveItem(index, 'down')"
          >
            ▼
          </button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ReorderableList',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    moveItem(index, direction) {
      const newItems = [...this.items]
      const newIndex = direction === 'up' ? index - 1 : index + 1
      
      if (newIndex >= 0 && newIndex < newItems.length) {
        // Swap items
        [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]]
        this.$emit('reorder', newItems)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.reorderable-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-item {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.list-item:last-child {
  border-bottom: none;
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-name {
  font-size: 14px;
  @media screen and (max-width: 600px) {
    font-size: 12px;
  }
}

.item-controls {
  display: flex;
  gap: 4px;
}

.arrow-btn {
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  color: #666;
}

.arrow-btn:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #ccc;
}

.arrow-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>